exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-blue[data-v-b80800ea] {\n  background-color: #77A9FD;\n  border: 1px solid #77A9FD;\n  width: 47vw;\n}\n.section[data-v-b80800ea] {\n  padding: 0 10px;\n}\n.req-title[data-v-b80800ea] {\n  font-size: 16px;\n  color: #111;\n  margin: 8px 10px;\n}\n.asterisk[data-v-b80800ea] {\n  color: #f44;\n  margin-right: 4px;\n}\n.desc-tip[data-v-b80800ea] {\n  color: #f44;\n  font-size: 12px;\n  margin: 2px 10px 8px;\n}\n.sub-group[data-v-b80800ea] {\n  padding: 6px 10px 10px 28px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b80800ea","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/MobileTicketComplaintNew.vue
// module id = 635
// module chunks = 75